import FormInputBase from './FormInputBase'
import RadioGroup from '@mui/material/RadioGroup'
import Radio from '@mui/material/Radio'
import FormControlLabel from '@mui/material/FormControlLabel'

const FormRadio = ({ itemProps = {}, formProps = {}, inputConfig = {} }) => {
  const { options, onSubmit, inputBaseProps } = inputConfig || {}
  const { field: { ref, ...fieldProps } = {}, fieldState: { error } = {} } = formProps || {}

  const { disabled, label } = itemProps || {}

  return (
    <FormInputBase
      label={label}
      error={error}
      onSubmit={
        onSubmit
          ? () => {
              onSubmit(fieldProps.value)
            }
          : null
      }
      disabled={disabled}
      inputBaseProps={inputBaseProps}
    >
      <RadioGroup row {...fieldProps}>
        {options.map(option => {
          const { label: optLabel, value: optValue, ...optionProps } = option

          return (
            <FormControlLabel
              key={`radiobtn_${optValue}}`}
              value={optValue}
              label={optLabel}
              control={
                <Radio
                size='small'
                  sx={{
                    color: theme => theme.palette.secondary_80.main,
                    '&.Mui-checked': {
                      color: theme => theme.palette.secondary_80.main,
                    },
                  }}
                />
              }
              {...optionProps}
            />
          )
        })}
      </RadioGroup>
    </FormInputBase>
  )
}

export default FormRadio
